// CSV export for the detail tables. lib/csv.js only PARSES (the leads import);
// this is the other direction, kept tiny and RFC-4180 strict: every field that
// holds a comma, quote, CR or LF is quoted and quotes are doubled. Rows end in
// CRLF and the file opens with a BOM so Excel reads UTF-8 names correctly —
// the investor opening "bo-outreach-90d.csv" should see "Müller Masonry", not
// mojibake.

export function csvField(value) {
  if (value === null || value === undefined) return ''
  let s
  if (value instanceof Date) s = Number.isNaN(value.getTime()) ? '' : value.toISOString()
  else if (typeof value === 'object') s = JSON.stringify(value)
  else s = String(value)
  // A leading = + - @ can be executed as a formula by spreadsheet apps when the
  // file is opened blind. Prefix with a quote so the cell is text — this is
  // data that came from email subjects and company names written by strangers.
  if (/^[=+\-@]/.test(s)) s = `'${s}`
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s
}

/**
 * columns: [{ header, value(row) }] — `value` returns a primitive or Date.
 * Returns the full text including the header row.
 */
export function toCsv(columns, rows) {
  const lines = [columns.map((c) => csvField(c.header)).join(',')]
  for (const row of rows || []) {
    lines.push(
      columns
        .map((c) => {
          try {
            return csvField(typeof c.value === 'function' ? c.value(row) : row[c.key])
          } catch {
            return ''
          }
        })
        .join(','),
    )
  }
  return `\ufeff${lines.join('\r\n')}\r\n`
}

// Same Blob + object-URL hand-off as chatExport.downloadMarkdown (never a
// data: URL — some browsers cap those at a few MB and an all-time outreach
// table can be larger).
export function downloadCsv(filename, text) {
  const blob = new Blob([String(text ?? '')], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename || 'export.csv'
  document.body.appendChild(a)
  a.click()
  a.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

// A filename piece: lowercase, non-alphanumerics collapsed to '-'.
export function fileSlug(value) {
  return (
    String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'export'
  )
}
